export const enHomeTranslation = {
  home: {
    welcome_back: 'Welcome back, {{name}}',
    subtitle: 'Here is an updated summary of your company’s latest metrics',

    viewing_now: 'Now viewing',
    company: 'Company',
    month: 'Month',

    notifications: {
      title: 'Notifications',
      empty: 'No notifications',
    },

    charts: {
      payroll_cost: {
        title: 'Monthly Payroll Cost',
      },
      salary_mass_by_level: {
        title: 'Payroll mass by level',
      },
      headcount_by_level: {
        title: 'Headcount by Level',
      },
      personnel_cost_result: {
        title: 'Personnel cost / results',
        net_revenue: 'Net Revenue',
        ebitda: 'EBITDA',
        personnel_cost: 'Personnel Cost',
        personnel_cost_by_ebitda: 'Personnel Cost / EBITDA',
        personnel_cost_by_net_revenue: 'Personnel Cost / Net Revenue',
      },
      current_payroll: {
        title: 'Current Payroll Monthly',
        nominal: 'Gross',
        with_charges: 'With charges',
        info: 'This is the projected annual total payroll cost.\n\nNominal: The sum of all gross wages (base salary) before additional costs.\n\nWith charges: The full effective cost to the company, including salaries, social charges (INSS, FGTS), benefits, and accruals (13th salary, vacation).',
      },
      payroll_budget: {
        title: 'Annual Payroll Budget',
        nominal: 'Gross',
        with_charges: 'With charges',
        info: 'This is the total payroll cost for the current month.\n\nGross: The sum of all gross wages (base salary) paid in this month.\n\nWith charges: The month’s full effective cost to the company, including salaries, social charges (INSS, FGTS), benefits, and monthly accruals (13th salary, vacation).',
      },
      average_salary: {
        title: 'Average Salary by Level',
        salary_fixed: 'Salary + Fixed Allowances',
        icp: 'STI',
        ilp: 'LTI',
        benefits: 'Benefits',
      },
      position_rate: {
        title: 'Positioning in the salary range',
        below_range: 'Below the range',
        between_min_100: 'Between minimum and 100%',
        between_100_max: 'Between 100% and maximum',
        above_max: 'Above maximum',
      },
      headcount: {
        title: 'Headcount',
      },
    },
  },
};
